module.exports = __webpack_public_path__ + "static/img/太魯閣山月村.549da0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/太魯閣山月村.png?20181011
// module id = xylY
// module chunks = 1